import CompetitionLayout from './competition_layout.jsx'

const CompetitionPage = () => {
  return (
      <CompetitionLayout />
  );
};

export default CompetitionPage;